import axios from 'axios';
import {apiService} from "../../services/api.service";
import {convertToPageable, extractData, handleResponse} from "../../helpers/apiResponseHelper";
import { PartnerForm } from './models';

async function findPartners(pageRequest: any) {
    return axios.get(`${apiService.getApiUrl()}/partners/admin`, {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable);
}

async function postPartner(request: PartnerForm) {
    return axios.post(`${apiService.getApiUrl()}/partners/admin`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function putPartner(id: number, request: PartnerForm) {
    return axios.put(`${apiService.getApiUrl()}/partners/admin/${id}`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function deletePartner(id: number) {
    return axios.delete(`${apiService.getApiUrl()}/partners/admin/${id}`)
        .then(handleResponse);
}

export const PartnersService = {
    findPartners,
    postPartner,
    putPartner,
    deletePartner
};
